var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWebsite = function SvgIconWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-website_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.932 17.25h7.636a7.894 7.894 0 0 1-1.19 2.628c-.554.794-1.116 1.19-1.685 1.19-.27 0-.494.09-.673.27-.18.18-.27.42-.27.719 0 .27.09.494.27.674.18.18.404.269.673.269h9.614c.27 0 .494-.09.674-.27.18-.18.269-.404.269-.673 0-.3-.09-.54-.27-.72a.914.914 0 0 0-.673-.269c-.57 0-1.13-.396-1.685-1.19a7.894 7.894 0 0 1-1.19-2.628h7.636c.54 0 .996-.187 1.37-.561.375-.375.562-.832.562-1.37V1.931c0-.54-.187-.996-.561-1.37A1.864 1.864 0 0 0 21.069 0H1.931c-.54 0-.996.187-1.37.562A1.864 1.864 0 0 0 0 1.932v13.386c0 .54.187.996.562 1.37.374.375.83.562 1.37.562Zm7.636 3.818c1.079-1.467 1.722-2.74 1.932-3.818.45 1.797 1.093 3.07 1.932 3.818H9.568ZM1.932 1.932h19.136V11.5H1.932V1.932Zm0 11.5h19.136v1.886H1.932v-1.886Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-website_svg__a",
    x: 0,
    y: 0,
    width: 23,
    height: 23.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.360784 0 0 0 0 0.541176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1713_46248"
  })))));
};
export default SvgIconWebsite;